export const DIAGNOSIS_KEYWORD_LIST = [
  { text: 'Acute respiratory infection', value: 'Acute respiratory infection' },
  { text: 'Headache', value: 'Headache' },
  { text: 'Myalgia', value: 'Myalgia' },
  { text: 'Fever', value: 'Fever' },
  { text: 'Sprain', value: 'Sprain' },
  { text: 'Conjunctivitis', value: 'Conjunctivitis' },
  { text: 'Stress', value: 'Stress' },
];
